<template>
  <ul class="flex space-x-3">
    <li class="flex items-center">
      <button
        type="button"
        class="focus:outline-none"
        @click="clickLink('Dashboard')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="
            h-5
            w-5
            text-gray-400
            hover:text-cyan-600
            transition
            duration-150
          "
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
          />
        </svg>
      </button>
    </li>
    <li
      v-for="breadcrumb in breadcrumbs"
      :key="breadcrumb.text"
      class="flex items-center space-x-3"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-gray-400"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        />
      </svg>
      <button
        type="button"
        class="
          text-base text-gray-900
          hover:text-cyan-600
          transition
          duration-150
          focus:outline-none
        "
        @click="clickLink(breadcrumb.routeName)"
      >
        {{ breadcrumb.text }}
      </button>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState(['breadcrumbs']),

  methods: {
    clickLink(routeName) {
      if (this.$route.name !== routeName) this.$router.push({ name: routeName })
    },
  },
}
</script>
